import React, { Component } from "react";
import { flattenOptions, getProvider } from "../shared/data";

const WithAsync = (WrappedInput) => {
    return class Async extends Component {
        constructor(props) {
            super(props);

            this.state = {
                options: props.options || [],
            };
        }

        componentDidMount() {
            if (this.props.loadOptions || this.props.provider) {
                this.loadOptions();
            }
        }

        componentDidUpdate(prevProps) {
            if (this.props.options !== prevProps.options) {
                this.setState({
                    options: this.props.options,
                });
            }
        }

        loadOptions = async () => {
            const options = this.props.provider
                ? flattenOptions(await getProvider(this.props.provider))
                : flattenOptions(await this.props.loadOptions(value));

            // Catch for success or failure
            if (options.success || options.error) {
                return;
            }

            this.setState({
                options,
            });
        };

        render() {
            return <WrappedInput {...this.props} options={this.state.options} />;
        }
    };
};

export default WithAsync;
